import {Component, forwardRef, input, output, viewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {MessageTranslateService} from '@app/shared/services';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {SimpleOption} from '@app/shared/model/simple-option';
import {AppConstants} from '@shared/util/app-constants';

export enum AlertStatus {
  FAULT = 'fault',
  RECOVERED = 'recovered',
  CLOSED = 'closed',
  IGNORED = 'ignored',
}


const options: SimpleOption<AlertStatus, I18nMessage>[] = [
  {value: AlertStatus.FAULT, label: {messageKey: 'Fault'}},
  {value: AlertStatus.RECOVERED, label: {messageKey: 'Recovered'}},
  {value: AlertStatus.CLOSED, label: {messageKey: 'Closed'}},
  {value: AlertStatus.IGNORED, label: {messageKey: 'Ignored'}},
];


@Component({
  selector: 'app-alert-status-select',
  templateUrl: './alert-status-select.component.html',
  standalone: false,
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AlertStatusSelectComponent), multi: true}
  ]
})
export class AlertStatusSelectComponent implements ControlValueAccessor {
  readonly options: SimpleOption<AlertStatus>[];
  readonly valueKey: keyof SimpleOption = 'value';
  readonly labelKey: keyof SimpleOption = 'label';
  readonly DROPDOWN_HOLDER_SELECTOR = AppConstants.DROPDOWN_HOLDER_SELECTOR;

  maxSelectedLabels = input(1);
  placeholder = input<string | null>(null);
  multiSelect = input(true);
  openEvent = output<any>();
  closeEvent = output<any>();
  aceSelect = viewChild.required(AceSelectComponent);

  constructor(translateService: MessageTranslateService) {
    this.options = options.map(option => ({...option, label: translateService.instant(option.label)}));
  }

  writeValue(value: AlertStatus[] | AlertStatus): void {
    this.aceSelect().writeValue(value);
  }

  registerOnChange(fn: (value: AlertStatus[] | AlertStatus) => void): void {
    this.aceSelect().registerOnChange(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.aceSelect().registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.aceSelect().setDisabledState(isDisabled);
  }

  onOpenEvent(event: any): void {
    this.openEvent.emit(event);
  }

  onCloseEvent(event: any): void {
    this.closeEvent.emit(event);
  }
}
